import ExperienceComponent from "../../Components/ExperienceComponent/ExperienceComponent";



export default function ExperiencePage(){
    return(
        <>
            <ExperienceComponent/>
        </>
    )
}